import { DAYS_SHORT } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { MealCreditInfoTextProps } from './constructMealCreditInfoText.utils';

export function formatSelectedDays(
  props: Pick<MealCreditInfoTextProps, 'selectedDays'>
): string {
  const { selectedDays } = props;
  const selectedDayNames = selectedDays
    .map((selected, index) => (selected ? DAYS_SHORT[index] : null))
    .filter((day) => day);

  if (selectedDayNames.length === 7 || selectedDayNames.length === 0) {
    return '';
  }

  if (selectedDayNames.length === 1) {
    return selectedDayNames[0];
  }

  const allButLast = selectedDayNames.slice(0, -1);
  const lastDay = selectedDayNames[selectedDayNames.length - 1];
  return `${allButLast.join(', ')}, and ${lastDay}`;
}
